module.exports = __webpack_public_path__ + "static/media/sidebar.07fc05b2.png";